function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("polygon", {
  points: "26.1 102.64 35.03 102.64 35.03 121.9 49.51 121.9 49.51 102.64 58.92 102.64 42.51 88.19 26.1 102.64"
}), React.createElement("polygon", {
  points: "112.01 88.19 95.6 102.64 104.53 102.64 104.53 121.9 119 121.9 119 102.64 128.41 102.64 112.01 88.19"
}), React.createElement("path", {
  d: "M165.17,105.58a59.82,59.82,0,0,0-10.17.88V0H0V150H107.19a60,60,0,1,0,58-44.42ZM91.32,10V52H63.68V10ZM10,140V10H53.68V62h47.64V10H145v99.07A60.29,60.29,0,0,0,110.87,140Zm155.17,75.4a49.91,49.91,0,1,1,50-49.91A50,50,0,0,1,165.17,215.4Z"
}), React.createElement("path", {
  d: "M165.17,137a28.52,28.52,0,0,0-28.52,28.47h10A18.52,18.52,0,1,1,165.41,184V172.47l-14.48,16.38,14.48,16.37V194a28.47,28.47,0,0,0-.24-56.93Z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 225.18 225.4"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/synchron.84320542.svg";
export { SvgComponent as ReactComponent };